// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_readiness.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * A read-only advisory projection. It neither approves nor blocks recording an
 * actual submission, and never guarantees government acceptance.
 *
 * @generated from message mono.projectdata.v1.GetRfiReadinessRequest
 */ export class GetRfiReadinessRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiReadinessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiReadinessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiReadinessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiReadinessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiReadinessRequest, "runtime", proto3);
_define_property(GetRfiReadinessRequest, "typeName", "mono.projectdata.v1.GetRfiReadinessRequest");
_define_property(GetRfiReadinessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiReadinessIssue
 */ export class RfiReadinessIssue extends Message {
    static fromBinary(bytes, options) {
        return new RfiReadinessIssue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiReadinessIssue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiReadinessIssue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiReadinessIssue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string code = 1;
   */ _define_property(this, "code", ""), /**
   * incomplete | not_checked. Unsupported and unknown checks never pass.
   *
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string explanation = 3;
   */ _define_property(this, "explanation", ""), /**
   * question | section | follow_up | package | package_item | check
   *
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 5;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string source_label = 6;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string question_id = 7;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string section_id = 8;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiReadinessIssue, "runtime", proto3);
_define_property(RfiReadinessIssue, "typeName", "mono.projectdata.v1.RfiReadinessIssue");
_define_property(RfiReadinessIssue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiQuestionReadiness
 */ export class RfiQuestionReadiness extends Message {
    static fromBinary(bytes, options) {
        return new RfiQuestionReadiness().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiQuestionReadiness().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiQuestionReadiness().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiQuestionReadiness, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string question_id = 1;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: bool mapped = 3;
   */ _define_property(this, "mapped", false), /**
   * @generated from field: bool drafted = 4;
   */ _define_property(this, "drafted", false), /**
   * @generated from field: bool reviewed = 5;
   */ _define_property(this, "reviewed", false), /**
   * @generated from field: bool ready = 6;
   */ _define_property(this, "ready", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiQuestionReadiness, "runtime", proto3);
_define_property(RfiQuestionReadiness, "typeName", "mono.projectdata.v1.RfiQuestionReadiness");
_define_property(RfiQuestionReadiness, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mapped",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "drafted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "reviewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "ready",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiReadinessResponse
 */ export class GetRfiReadinessResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiReadinessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiReadinessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiReadinessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiReadinessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.RfiQuestionReadiness questions = 2;
   */ _define_property(this, "questions", []), /**
   * @generated from field: repeated mono.projectdata.v1.RfiReadinessIssue issues = 3;
   */ _define_property(this, "issues", []), /**
   * @generated from field: int32 section_count = 4;
   */ _define_property(this, "sectionCount", 0), /**
   * @generated from field: int32 drafted_sections = 5;
   */ _define_property(this, "draftedSections", 0), /**
   * @generated from field: int32 reviewed_sections = 6;
   */ _define_property(this, "reviewedSections", 0), /**
   * @generated from field: int32 open_follow_ups = 7;
   */ _define_property(this, "openFollowUps", 0), /**
   * @generated from field: int32 package_count = 8;
   */ _define_property(this, "packageCount", 0), /**
   * @generated from field: int32 package_item_count = 9;
   */ _define_property(this, "packageItemCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiReadinessResponse, "runtime", proto3);
_define_property(GetRfiReadinessResponse, "typeName", "mono.projectdata.v1.GetRfiReadinessResponse");
_define_property(GetRfiReadinessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "questions",
            kind: "message",
            T: RfiQuestionReadiness,
            repeated: true
        },
        {
            no: 3,
            name: "issues",
            kind: "message",
            T: RfiReadinessIssue,
            repeated: true
        },
        {
            no: 4,
            name: "section_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "drafted_sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "reviewed_sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "open_follow_ups",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "package_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "package_item_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
